import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface NavBarLinksProps {
  isBottomNav?: boolean;
}

export const NavBarLinks: React.FC<NavBarLinksProps> = ({ isBottomNav }) => {
  const { hasPermission } = useAuth();
  const iconClass = isBottomNav ? 'fs-3' : ''; // Apply larger icon size for bottom nav

  return (
    <>
      {hasPermission('calendar_page', 'can_read') && (
        <NavLink to="/calendar" className="nav-link">
          <i className={`bi bi-calendar-event ${iconClass}`}></i>
          {!isBottomNav && 'Kalender'}
        </NavLink>
      )}
      {hasPermission('documents_page', 'can_read') && (
        <NavLink to="/documents" className="nav-link">
          <i className={`bi bi-file-earmark-text ${iconClass}`}></i>
          {!isBottomNav && 'Dokumente'}
        </NavLink>
      )}
      {hasPermission('gebiete_page', 'can_read') && (
        <NavLink to="/gebiete" className="nav-link">
          <i className={`bi bi-map ${iconClass}`}></i>
          {!isBottomNav && 'Gebiete'}
        </NavLink>
      )}
      
      {hasPermission('add_termin_page', 'can_read') && (
        <NavLink to="/add-termin" className="nav-link">
          <i className={`bi bi-plus-circle ${iconClass}`}></i>
          {!isBottomNav && 'Termin hinzufügen'}
        </NavLink>
      )}
      {hasPermission('settings_page', 'can_read') && (
        <NavLink to="/settings" className="nav-link">
          <i className={`bi bi-gear ${iconClass}`}></i>
          {!isBottomNav && 'Einstellungen'}
        </NavLink>
      )}
    </>
  );
};
